import React, { useState } from "react";
import { ChevronDown, ChevronUp, BookOpen } from "lucide-react";

interface PageInstructionsProps {
  title?: string;
  steps: string[];
}

const PageInstructions: React.FC<PageInstructionsProps> = ({ title = "📖 Como usar esta página", steps }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="w-full mb-4">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between gap-2 px-4 py-3 rounded-xl border-2 border-primary/30 bg-primary/5 hover:bg-primary/10 transition-colors text-left"
      >
        <span className="flex items-center gap-2 font-bold text-primary text-sm sm:text-base">
          <BookOpen className="h-5 w-5 shrink-0" />
          {title}
        </span>
        {isOpen ? (
          <ChevronUp className="h-5 w-5 text-primary shrink-0" />
        ) : (
          <ChevronDown className="h-5 w-5 text-primary shrink-0" />
        )}
      </button>

      {isOpen && (
        <div className="mt-2 p-4 rounded-xl border-2 border-primary/20 bg-card animate-in slide-in-from-top-2 duration-300">
          <ol className="space-y-3">
            {steps.map((step, index) => (
              <li key={index} className="flex items-start gap-3">
                <span className="flex items-center justify-center h-7 w-7 rounded-full bg-primary text-primary-foreground text-sm font-bold shrink-0">
                  {index + 1}
                </span>
                <span className="text-sm sm:text-base text-foreground leading-relaxed pt-0.5">
                  {step}
                </span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
};

export default PageInstructions;
